import React, { useState, useEffect } from "react";
import axiosInstance from "../utills/axiosInstance";
import './Offboarding.css';

const AdminApprovalDashboard = () => {
    const [requests, setRequests] = useState([]);

    useEffect(() => {
        axiosInstance.get(`/api/pending`).then(res => setRequests(res?.data));
    }, []);

    const handleFinalDecision = async (id, approve) => {
        const remarks = approve
            ? prompt("Enter final remarks (optional):") || "Approved by Admin"
            : prompt("Enter rejection reason:") || "Rejected by Admin";

        if (!remarks) return;

        try {
            const res = await axiosInstance.put(`/api/admin-approve/${id}`, { approve, remarks });
            setRequests(prev => prev.filter(r => r._id !== id));
            alert(approve ? "Final Approval Granted!" : "Offboarding Rejected");
        } catch (err) {
            alert("Error processing final approval");
        }
    };

    console.log(requests);

    return (
        <div className="app-container">
            <div className="header-section">
                <h2 className="page-title">Offboarding - Final Admin Approval</h2>
            </div>

            <div className="upload-form">
                {requests?.length === 0 ? (
                    <p className="text-center text-gray-600 py-10">No requests pending final approval</p>
                ) : (
                    requests?.map(req => (
                        <div key={req._id} className="form-section mb-6 border-l-4 border-blue-600">
                            <h3 className="font-bold text-xl mb-3">{req.employee.firstName} {req.employee.lastName}</h3>
                            <div className="form-grid">
                                <div><strong>Emp ID:</strong> {req.employee.empId}</div>
                                <div><strong>Department:</strong> {req.employee.department}</div>
                                <div><strong>Reason:</strong> {req.reasonForLeaving} {req.otherReason}</div>
                                <div><strong>LWD:</strong> {new Date(req.lastWorkingDay).toLocaleDateString()}</div>
                            </div>
                            <div className="mt-4 p-4 bg-green-50 rounded border-l-4 border-green-500">
                                <p className="font-medium text-green-800">RM Approved by {req.rmApprovedBy?.firstName} {req.rmApprovedBy?.lastName}</p>
                                {req.rmRemarks && <p className="italic mt-1">"{req.rmRemarks}"</p>}
                            </div>
                            <div className="mt-5 flex gap-4">
                                <button onClick={() => handleFinalDecision(req._id, true)} className="btn btn-primary text-lg px-8">
                                    Final Approve
                                </button>
                                <button onClick={() => handleFinalDecision(req._id, false)} className="btn bg-red-600 hover:bg-red-700 text-lg px-8">
                                    Reject
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default AdminApprovalDashboard;
